/**
 * A client-side unique id that works in NON-secure contexts.
 *
 * `crypto.randomUUID()` exists ONLY in a secure context (HTTPS or
 * `localhost`). When Tray is reached over plain HTTP on a LAN IP
 * (e.g. `http://192.168.1.x:5173` during a smoke test) the whole
 * `crypto.randomUUID` is `undefined` and any caller throws. These ids
 * are for local React keys / draft-row identity only — never security
 * material — so a non-crypto fallback is perfectly fine.
 */
export function uid(prefix = "id"): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === "function") {
    return c.randomUUID();
  }
  // Fallback for insecure origins: timestamp + random suffix. Unique
  // enough for in-memory keys; not a UUID and not meant to be.
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
